// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import IssuuLookupModel from '../../model/issuu-lookup-model';
import IssuuLookupDTO from '../dto/issuu-lookup-dto';
import dtoSchema from '../schemas/issuu-lookup-schema';

export default abstract class IssuuLookupModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<IssuuLookupDTO>) {
    super();
    if (data) {
      this.id = data.id ?? undefined;
      this.caption = data.caption ?? undefined;
    }
  }
  /**
  */
  id?: string;
  /**
  */
  caption?: string;

  static toModel(dto: DeepPartial<IssuuLookupDTO>): IssuuLookupModel;
  static toModel(dto: DeepPartial<IssuuLookupDTO> | undefined | null): IssuuLookupModel | undefined;
  static toModel(dto: DeepPartial<IssuuLookupDTO> | undefined | null): IssuuLookupModel | undefined {
    return dto ? new IssuuLookupModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<IssuuLookupModel> | IssuuLookupModel): IssuuLookupDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      caption: unwrapped.caption,
    } as IssuuLookupDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for IssuuLookupModel, can not map to IssuuLookupDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
